import * as mockService from "./mockDataService";

var api = {
  getScreens: function() {
    return mockService.getAllScreens();
  },
  getScreen: function(screenNumber) {
    return mockService.getScreen(screenNumber);
  },
  updateScreen: function(screenNumber, updates) {
    return mockService.updateScreen(screenNumber, updates);
  },
  bulkUpdateScreens: function(screenIds, updates) {
    return mockService.bulkUpdateScreens(screenIds, updates);
  },
  resetScreen: function(screenNumber) {
    return mockService.resetScreen(screenNumber);
  },
  copyScreenConfig: function(targetScreen, sourceScreen) {
    return mockService.copyScreenConfig(targetScreen, sourceScreen);
  },
  uploadLogo: function(file) {
    return new Promise(function(resolve, reject) {
      var reader = new FileReader();
      reader.onload = function() {
        resolve({ url: reader.result });
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  },
  onScreenChange: function(screenNumber, callback) {
    return mockService.onScreenChange(screenNumber, callback);
  },
  onAllScreensChange: function(callback) {
    return mockService.onAllScreensChange(callback);
  },
  isUsingMockData: function() {
    return mockService.isUsingMockData();
  },
  triggerRefresh: function() {
    return mockService.triggerRefresh();
  },
  onRefreshSignal: function(callback) {
    return mockService.onRefreshSignal(callback);
  }
};

export default api;
